
(function($){
	$(function(){



        $('.tropical-tab-trigar ul li').click(function(){
            $('.tropical-tab-trigar ul li').removeClass('active-btn');
            $(this).addClass('active-btn');
            $('.accordion').hide();

            var activeTab = $(this).find('a').attr('href');
            $(activeTab).fadeIn();
            return false;
        });

        //FAQs Accordion Function
        $(".accordion-item").each(function(){
            var $this = $(this);
            $this.find(" > h5").on("click touch", function(){
                $(".accordion-item").removeClass("active")
                $(".accordion-item .accordion-text").slideUp();
                if($this.find(".accordion-text:visible").length){
                    $(".accordion-item").removeClass("active")
                    $(".accordion-item .accordion-text").slideUp();
                }
                else{
                    $this.addClass("active")
                    $(".accordion-item .accordion-text").slideUp();
                    $this.find(" > .accordion-text").slideDown();
                }
            })
        })
        
 
        if ($('#marque-slider').length) {
            $('#marque-slider').slick({
                speed: 5000,
                autoplay: true,
                autoplaySpeed: 0,
                centerMode: false,
                swipe: false,
                cssEase: 'linear',
                slidesToShow:1,
                slidesToScroll: 1,
                variableWidth: true,
                infinite: true,
                initialSlide: 1,
                arrows: false,
                buttons: false,
                pauseOnHover: false,
            });
        }
        
        if($('#review-slider').length){
            $('#review-slider').slick({
                dots: true,
                arrows: false,
                autoplay: false,
                infinite: false,
                navigation: false,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                asNavFor: '.review-thumb'
            });

            $('.review-thumb').slick({
                dots: false,
                arrows: false,
                autoplay: false,
                infinite: false,
                navigation: false,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                asNavFor: '#review-slider'
            });
        }
        

      
        // if($('.variant-slider').length){
        //     $('.variant-slider').slick({
        //         dots: true,
        //         arrows:true,
        //         autoplay:false,
        //         autoplaySpeed:5000,
        //         infinite: true,
        //         navigation:false,
        //         speed: 300,
        //         slidesToShow:1,
        //         slidesToScroll: 1,
        //         adaptiveHeight: true,
        //     });
        // }
        

        $('.variant-slider__main').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            arrows: false,
            dots: false,
            adaptiveHeight: true,
            asNavFor: '.variant-slider__thumb',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: 'unslick'
                }
            ]
          });
          $('.variant-slider__thumb').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            mobileFirst: true,
            arrows: false,
            dots: false,
            focusOnSelect: true,
            // variableWidth:true,
            asNavFor: '.variant-slider__main',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: 'unslick'
                }
            ]
          });




        if ($('.insta-slider-wrap').length) {
            $('.insta-slider-wrap').slick({
                speed: 5000,
                autoplay: true,
                autoplaySpeed: 0,
                centerMode: false,
                swipe: false,
                cssEase: 'linear',
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                infinite: true,
                initialSlide: 1,
                arrows: false,
                buttons: false,
                pauseOnHover: false,
            });
        }


        if ($('select').length) {
            $('select').selectric({
                disableOnMobile: false,
                nativeOnMobile: false
            });
        }

        $(".product-accordion-item").each(function(){
            var $this = $(this);
            $this.find(" > h5").on("click touch", function(){
                $(".product-accordion-item").removeClass("active")
                $(".product-accordion-item .product-details").slideUp();
                if($this.find(".product-details:visible").length){
                    $(".product-accordion-item").removeClass("active")
                    $(".product-accordion-item .product-details").slideUp();
                }
                else{
                    $this.addClass("active")
                    $(".product-accordion-item .product-details").slideUp();
                    $this.find(" > .product-details").slideDown();
                }
            })
        })
        

// add to cart 


  







        $('.cart-trigger').on('click', function(){
            $('body').addClass('cartShow')
        })
        // $('.back-arrow, .product-cart-wrap').on('click', function(){
        //     $('body').removeClass('cartShow')
        // })
        $('.product-cart-main-area').on('click', function(e){
            e.stopPropagation()
        })




        $('.newsletter-input').on('click', function(){
            $('body').addClass('modalShow')
        })
        $('.close-arrow, .newsletter-modal-wrap').on('click', function(){
            $('body').removeClass('modalShow')
        })
        $('.newsleter-modal-inner').on('click', function(e){
            e.stopPropagation()
        })



        if ($('.products-item-wrap').length) {
            $(window).on('load resize', function() {
                if ($(window).width() <= 991) {
                    $('.products-item-wrap').slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        arrows: false,
                        dots: true,
                        autoplay: true,
                        autoplaySpeed: 3000,
                        speed: 1000,
                        infinite: true,
                        variableWidth: false,
                        adaptiveHeight: true,
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: 'unslick'
                            }
                        ]
                        
                    });
                } 
                // else {
                 
                //     if ($('.products-item-wrap').hasClass('slick-initialized')) {
                //         $('.products-item-wrap').slick('unslick');
                //     }
                // }
            });
        }



        $('.accordion').hide();
        $('#product').show();
    
        // Dropdown change event
        $('#select-box').change(function () {
            var dropdown = $('#select-box').val();
    
            // Hide all accordions
            $('.accordion').hide();
    
            // Show the selected accordion
            $('#' + dropdown).show();
        });


        $('.anchor-link').click(function(e){
            e.preventDefault();
            var target = $($(this).attr('href'));
            if(target.length){
                var scrollTo = target.offset().top;
                $('body, html').animate({scrollTop: scrollTo + 'px'}, 1000); 
            }
        });





	})// End ready function.
   


 // marque custom start

 $(".marque__images").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });


// marque custom end



// works start


if ($(Window).width() < 768) {
    $('.works__content-items').slick({
        dots:true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
      {
          breakpoint: 768,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
      },
  ]
});
  }


// works end


// highlights start


if ($(Window).width() < 768) {
    $('.highlights__items').slick({
        dots:true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
      {
          breakpoint: 768,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
      },
  ]
});
  }


// highlights end



 
    var product_encodedObject = document.querySelector('script[data-product-json]').textContent;
    var product_dataObject = JSON.parse(product_encodedObject);
    var variants = product_dataObject.variants;
    let userSelectValues = [...variants];


    $('.select-btn').on('change', function() {
        $('.product-type').removeClass('active');
        $('.product-type.single').addClass('active');
        userSelectValues = [];
        userSelectValues.push(this.value);

          let matchedVariants = variants.find(variant => {
                let match = true;
                    
                for (let i = 0; i < userSelectValues.length; i++) {
                    if (userSelectValues.indexOf(variant.options[i]) == -1) {
                        match = false;
                        break;
                    }
                }
                
                return match;
            });

          
            document.querySelector('.single-product-form input[name="id"]').value = matchedVariants.id;
            $('.product-type.single').attr('data-product', matchedVariants.id);
    
            var price =   document.querySelector('.related-item-price .price');
            var com_price =   document.querySelector('.related-item-price del');

            console.log(matchedVariants.price);
            if(price != null ){
                price.innerHTML = `${shopCurrencySign}${(matchedVariants.price / 100).toFixed(2)}`;
                com_price.innerHTML = `${shopCurrencySign}${(matchedVariants.compare_at_price / 100).toFixed(2)}`;
              }

            if( matchedVariants.featured_image != null){

                $(".selectric .label").addClass('active');
            
              $(".selectric .label").css({ "--url": 'url('+matchedVariants.featured_image.src+')' });

            }else{
                $(".selectric .label").removeClass('active');
            }

            if(matchedVariants.available == false ){
                document.querySelector('.add-btn').classList.add('disable');
            }else{
                document.querySelector('.add-btn').classList.remove('disable');
            }

            // console.log(matchedVariants);

            $('.variant-slider').removeClass('active');
            var selected_var = $(this).find('option:selected').attr('data-selected');
            $(selected_var).addClass('active');

      });




    



})(jQuery)


function closeCart(e,el){
    e.preventDefault();
    $('body').removeClass('cartShow')
}

$(document).on("click",".cart-overlary",function(e) {
    $("body").removeClass("cartShow");
});



function increaseCount(e, el) {
    var $input = el.previousElementSibling;
    var value = parseInt($input.value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    $input.value = ('0' + value).slice(-2);            
}

function decreaseCount(e, el) {
    var $input = el.nextElementSibling;
    var value = parseInt($input.value, 10);
    if (value > 1) {
        value = isNaN(value) ? 0 : value;
        value--;
        $input.value = ('0' + value).slice(-2);         
    }
}


function increaseCount1(e, el) {
    var $input = el.previousElementSibling;
    var value = parseInt($input.value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    $input.value = ('0' + value).slice(-2);            
    change_qty($input);
}

function decreaseCount1(e, el) {
    var $input = el.nextElementSibling;
    var value = parseInt($input.value, 10);
    if (value > 1) {
        value = isNaN(value) ? 0 : value;
        value--;
        $input.value = ('0' + value).slice(-2);         
        change_qty($input);
    }
}






$( ".add-btn").on("click", function (e) {
    e.preventDefault();
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $('.single-product-form').serialize(),
          success: function(data) {
             get_cart_details();
            $('body').addClass('cartShow');

          },
          error: 'addToCartFail'
      });
      
  });

  $(document).on("click",".upsell-product__btn a",function(e) {
    e.preventDefault();
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $(this).parent().find('.shopify-product-form').serialize(),
          success: function(data) {
             get_cart_details();
            $('body').addClass('cartShow');

          },
          error: 'addToCartFail'
      });
  });

  




function get_cart_details(){
    fetch("?section_id=cart-drawer")
      .then((response) => response.text())
      .then((cartData) => {
        var cart_html = $(cartData);
        var cart_items = $(".product-cart-wrap", cart_html);
        $(".product-cart-wrap").replaceWith(cart_items);

      });
  
      fetch("?section_id=header")
      .then((response) => response.text())
      .then((cartData) => {
        var cart_html = $(cartData);

        var cart_count = $(".cart-trigger dfn", cart_html);
        $(".cart-trigger dfn").replaceWith(cart_count);

      });
      
  
  };


function change_qty($input){
    var variant_id= $($input).attr("data-id");
    var quantity= $($input).val();          
    var data = { updates: {} };
    data.updates[variant_id] = quantity;
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(res) {               
        get_cart_details();
      }
    });
  };



  //   Remove
  function itemRemove(e , el){
    e.preventDefault();
    var variant_id = $(el).attr('data-id');
    var data = { updates: {} };
    data.updates[variant_id] = '0';
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(res) {
        get_cart_details();
      }
    });
        //  $(el).parent().parent().remove();
  }


var free_product_count = 0;
  $('.product-type').click(function(){
    free_product_count++;
    $('.product-type').removeClass('active');
    $(this).addClass('active');
    var selected_product = $(this).attr('data-product');
    var free_product = $('.free-product').attr('value');
    $('.product-id').val(selected_product);
    if(free_product_count <= 1){
        $('<input type="hidden" name="id[]" value="'+free_product+'">').insertAfter('.free-product');
    }
    
  });








 